 <!-- ***************SG-7147 strat  ******************* -->

 <div fxFlex="100%" fxLayout="column">
    <div fxLayout="column" fxFlex="100%">
        <mat-card class="parent-card">
            <mat-card-header class="card-head">
                <div class="export-icon"> <span class="mission-heading"> {{this.missionName}} Records</span>

                    <i class="fa fa-share-square-o" aria-hidden="true"
                        style="font-size: 24px;margin-top:10px; color: #707070; cursor: pointer;"
                        (click)="exportCsvData('performance')"></i>
                </div>
            </mat-card-header>
            <div class="table-class">
                <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8" width="100%">
                    <ng-container matColumnDef="sessionDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header width="14%"> Session Date </th>
                        <td mat-cell *matCellDef="let element" style="text-align: justify;"
                            [matTooltip]="element?.sessionDate | date:'MMMM d, y'" pointer
                            (click)="openUserDialog(element)">
                            {{element?.sessionDate | date:'MMMM d, y'}} </td>
                    </ng-container>
                    <ng-container matColumnDef="excellentHits">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header width="14%"> Excellent Hits </th>
                        <td mat-cell *matCellDef="let element" class="data-padding" [matTooltip]="element?.excellentHits" pointer>
                            {{element?.excellentHits}} </td>
                    </ng-container>
                    <ng-container matColumnDef="goodHits">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header width="14%"> Good Hits </th>
                        <td mat-cell *matCellDef="let element" class="data-padding" [matTooltip]="element?.goodHits" pointer>
                            {{element?.goodHits}} </td>
                    </ng-container>
                    <ng-container matColumnDef="missedHits">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header width="14%"> Missed Hits </th>
                        <td mat-cell *matCellDef="let element" class="data-padding" [matTooltip]="element?.missedHits" pointer>
                            {{element?.missedHits}} </td>
                    </ng-container>
                    <ng-container matColumnDef="voiceCommands">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header width="14%"> Voice Commands </th>
                        <td mat-cell *matCellDef="let element" class="data-padding" [matTooltip]="element?.voiceCommands" pointer>
                            {{element?.voiceCommands}} </td>
                    </ng-container>
                    <ng-container matColumnDef="textCommands">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header width="14%"> Text Commands </th>
                        <td mat-cell *matCellDef="let element" class="data-padding" [matTooltip]="element?.textCommands" pointer>
                            {{element?.textCommands}} </td>
                    </ng-container>
                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header width="14%"> Status </th>
                        <td mat-cell *matCellDef="let element" [matTooltip]="element?.status" pointer>
                            {{element?.status}} </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;" pointer></tr>
                </table>
            </div>
            <mat-paginator [pageSizeOptions]="[5,10, 25, 50]" [pageSize]="pageSize" [length]="missionRecords.length"
                (page)="onPageChange($event)"></mat-paginator>
        </mat-card>

    </div>

    <div fxLayout="row" [ngClass]="['card-height']" fxLayoutAlign="space-between" fxLayoutGap="10px">
        <mat-card class="flx-card wd-mx crd-ovrflw bottom-card-ht">
            <mat-card-header class="grp_hdr">
                <article [ngClass]="['header-padding']">
                    <div fxLayout="column" fxLayoutAlign="start center">
                        <h4 ngClass="selectlist-label" *ngIf="dateType?.type == 'month' || dateType?.type == 'Month'">
                            Last 24
                            Month's Data</h4>
                        <h4 ngClass="selectlist-label" *ngIf="dateType?.type == 'day' || dateType?.type == 'Day'">Last 1
                            Month's Data</h4>
                        <h4 ngClass="selectlist-label" *ngIf="dateType?.type === 'year' || dateType?.type === 'Year'">
                            Last 5
                            Year's Data</h4>
                    </div>
                    <nav class="nv_rt rpd">
                        <div fxLayout="row" fxLayoutGap="10px">
                            <div fxLayout="column" fxLayoutAlign="end center" class="chart-header-dropdown">
                                <div fxLayout="row">
                                    <h4 ngClass="selectlist-label"
                                        *ngIf="usageAnalyticsSelectedValue !== 'totalPlayedSession' &&
                                usageAnalyticsSelectedValue !== 'averageDuration' &&
                                usageAnalyticsSelectedValue!=='masteredPracticeSets' && usageAnalyticsSelectedValue === 'All'">
                                        Usage : </h4>
                                    <h4 ngClass="selectlist-label"
                                        *ngIf="usageAnalyticsSelectedValue === 'TotalSessions'">
                                        Total Missions Sessions :
                                    </h4>
                                    <h4 ngClass="selectlist-label"
                                        *ngIf="usageAnalyticsSelectedValue === 'AvgSessionDuration'">Average Mission
                                        Duration :
                                    </h4>
                                    <h4 ngClass="selectlist-label"
                                        *ngIf="usageAnalyticsSelectedValue === 'ClearedSessions'">Total Cleared Missions
                                        :
                                    </h4>

                                    <h4 ngClass="selectlist-label"
                                        *ngIf="usageAnalyticsSelectedValue === 'FailedSessions'">Total Not Cleared
                                        Missions :
                                    </h4>
                                    <h4 ngClass="selectlist-label"
                                        *ngIf="usageAnalyticsSelectedValue === 'VoiceCommands'">
                                        Total Voice Commands :
                                    </h4>
                                    <h4 ngClass="selectlist-label"
                                        *ngIf="usageAnalyticsSelectedValue === 'TextCommands'">
                                        Total Text Commands :
                                    </h4>
                                    <mat-form-field class="mrgn drpdown-chart-options duration-dropdown form-field"
                                        appearance="outline">
                                        <mat-select [(ngModel)]="usageAnalyticsSelectedValue" name="usageEramAnalytics"
                                            (selectionChange)="changeAnalytics($event.value)">
                                            <mat-option class="drp-options" *ngFor="let ua of usageEramAnalytics"
                                                [value]="ua.value">
                                                {{ua.viewValue}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div fxLayout="column">
                                <i class="fa fa-share-square-o" aria-hidden="true"
                                    style="font-size: 24px;margin-top:10px; color: #707070; cursor: pointer;"
                                    (click)="exportCsvData('usage')"></i>
                            </div>
                        </div>
                    </nav>
                </article>
            </mat-card-header>
            <mat-card-content class="flx_tm">
                <app-highcharts [totalLessionsSessions]="totalLessionsSessions" [updateChart]="updateChart">
                </app-highcharts>
            </mat-card-content>
        </mat-card>
    </div>
</div> 
 <!-- ***************SG-7147 end  ******************* -->

